/* Darling Lux — rotating announcement bar */
(() => {
  if (customElements.get('dlx-announcement')) return;

  class DlxAnnouncement extends HTMLElement {
    connectedCallback() {
      this.msgs = [...this.querySelectorAll('[data-msg]')];
      this.index = Math.max(0, this.msgs.findIndex((m) => m.classList.contains('is-active')));
      this.interval = Math.max(3000, Number(this.dataset.interval) || 4000);
      this.paused = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced) this.classList.add('is-reduced');

      this.setupDismiss();
      if (this.msgs.length < 2) return;

      this.onEnter = () => { this.paused = true; this.stop(); };
      this.onLeave = () => { this.paused = false; this.start(); };
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.onBlockSelect = (e) => {
        const i = this.msgs.findIndex((m) => m.dataset.blockId === (e.detail && e.detail.blockId));
        if (i < 0) return;
        this.stop();
        this.paused = true;
        this.show(i);
      };
      this.onBlockDeselect = () => { this.paused = false; this.start(); };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    setupDismiss() {
      if (!this.hasAttribute('data-dismissible')) return;
      const key = this.dataset.key;
      if (!window.Shopify || !window.Shopify.designMode) {
        try { if (sessionStorage.getItem(key) === '1') this.hidden = true; } catch (e) {}
      }
      const btn = this.querySelector('[data-dismiss]');
      if (btn) btn.addEventListener('click', () => {
        this.hidden = true;
        this.stop();
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }

    start() {
      if (this.timer || this.paused || this.hidden || document.hidden || this.msgs.length < 2) return;
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.msgs.length), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    show(next) {
      if (next === this.index) return;
      const current = this.msgs[this.index];
      const incoming = this.msgs[next];

      incoming.classList.add('no-transition');
      incoming.classList.remove('is-leaving', 'is-active');
      void incoming.offsetWidth;
      incoming.classList.remove('no-transition');

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      incoming.classList.add('is-active');

      window.setTimeout(() => current.classList.remove('is-leaving'), 500);
      this.index = next;
    }
  }

  customElements.define('dlx-announcement', DlxAnnouncement);
})();
